import { Modal } from '@/components/Modal';

interface MessageModalProps {
  title: string;
  description: string;
}

export const Message = ({ title, description }: MessageModalProps) => {
  return (
    <Modal title={title} description={<p>{description}</p>}>
      <Modal.Footer>
        <Modal.Close />
      </Modal.Footer>
    </Modal>
  );
};
